import NotEligibleScreen from 'features/lineOfCredit/screens/eligibility/NotEligibleScreen';
import React from 'react';

export default function Page() {
  return <NotEligibleScreen />;
}
